module.exports = __webpack_public_path__ + "img/img126.d0390b2e.svg";